"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityPickerWrapper = exports.NotifyMeIconButton = exports.IconWrapper = exports.IconButtonWithFixedSize = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const IconWrapper = exports.IconWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  position = 'bottom'
}) => ({
  bottom: position === 'bottom' ? theme.spacing(2) : 'initial',
  top: position === 'top' ? theme.spacing(2) : 'initial',
  display: 'flex',
  flexDirection: 'column-reverse',
  position: 'absolute',
  right: theme.spacing(2),
  zIndex: 2,
  gap: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(2)
  }
}));
const IconButtonWithFixedSize = exports.IconButtonWithFixedSize = (0, _mui.styled)(_components.IconButton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['buttonSize', 'iconSize'])
})(({
  buttonSize,
  iconSize,
  theme
}) => ({
  height: buttonSize,
  width: buttonSize,
  '& svg': {
    fontSize: iconSize
  },
  [theme.breakpoints.up('sm')]: {
    height: buttonSize,
    width: buttonSize,
    '& svg': {
      fontSize: iconSize
    }
  }
}));
const QuantityPickerWrapper = exports.QuantityPickerWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  bottom: theme.spacing(2),
  padding: theme.spacing(0, 2),
  position: 'absolute',
  right: 0,
  width: '100%',
  zIndex: 2
}));
const NotifyMeIconButton = exports.NotifyMeIconButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  [theme.breakpoints.up('sm')]: {
    height: 45,
    width: 45,
    fontSize: '2.7rem'
  }
}));
//# sourceMappingURL=styles.js.map